function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 26.4144,
  cy: 44.7653,
  r: 2.5,
  fill: "#18A43B"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 36.1265,
  cy: 44.7652,
  r: 3.21212,
  fill: "#18A43B"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 45.8386,
  cy: 44.7653,
  r: 2.5,
  fill: "#18A43B"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  y: 3.24707,
  width: 15,
  height: 32,
  rx: 3,
  fill: "#18A43B"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 17,
  y: 0.0163574,
  width: 39,
  height: 38.4613,
  rx: 5,
  fill: "#18A43B"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 58,
  y: 3.24707,
  width: 15,
  height: 32,
  rx: 3,
  fill: "#18A43B"
});

var SvgIconLayoutSlideActive = function SvgIconLayoutSlideActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 49,
    viewBox: "0 0 73 49",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLayoutSlideActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_layout_slide_active.7c43b179.svg";
export { ForwardRef as ReactComponent };